import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialLoadingStatus: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M30.47 10.66H32v10.67h-1.53Zm-1.52 10.67h1.52v1.52h-1.52Zm0-12.19h1.52v1.52h-1.52ZM3.05 22.85h25.9v1.53H3.05Zm16.76-10.66h-1.53v-1.53H4.57v1.53H3.05v7.62h1.52v1.52h13.71v-1.52h1.53v-1.53h1.52v-4.57h-1.52zM3.05 7.62h25.9v1.52H3.05ZM1.52 21.33h1.53v1.52H1.52Zm0-12.19h1.53v1.52H1.52ZM0 10.66h1.52v10.67H0Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialLoadingStatus
